import React from 'react';
import {Chip, Grid, Typography} from 'material-ui';

const SectionTitle = ({classes, placeholderName, title, disabled}) => {
    return (
        <Grid container style={{paddingBottom: '10px'}}>
            <Grid item xs={4}>
                <Grid container direction="row" justify="flex-start">
                    <Typography variant="title" gutterBottom className={classes.sectionTitle}>{title}</Typography>
                </Grid>
            </Grid>
            <Grid item xs={5}>
                {disabled &&
                    <Grid container direction="row" justify="center">
                        <Typography variant="title" gutterBottom className={classes.sectionTitle}><em>Section disabled from the website!</em></Typography>
                    </Grid>
                }
            </Grid>
            <Grid item xs={3}>
                <Grid container direction="row" justify="flex-end">
                    {placeholderName && <Chip label={placeholderName} className={classes.sectionTitleChip} />}
                </Grid>
            </Grid>
        </Grid>
    )
};

export default SectionTitle;


// WEBPACK FOOTER //
// ./src/containers/builder/sections/tab_edit/section_title.js